import React, { Component } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Card, Button, Col, Row, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { withLabelsContext } from "context";
import "./RubricsCard.css";
import {
  IconCalenderSurvey,
  IconInprogressSurvey,
  IconYetToStartSurvey,
  IconCompletedSurvey,
  IconClosedSurvey,
} from "Icons";
import { OverlayTooltip } from "components";
import styled, { useTheme } from "styled-components";

const StyledDiv = styled.div`
  && {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
    width: 100%;
  }
`;

function RubricsCard(props) {
  const theme = useTheme();

  const renderStatus = () => {
    const statusMap = {
      "In Progress": {
        icon: <IconInprogressSurvey height={12} width={12} className="align-svg" />,
        text: "IN PROGRESS",
        color: "#005eff",
      },
      "Yet to Start": {
        icon: <IconYetToStartSurvey height={12} width={12} className="align-svg" />,
        text: "YET TO START",
        color: "#ff9f00",
      },
      Attended: {
        icon: <IconCompletedSurvey height={12} width={12} className="align-svg" />,
        text: "ATTENDED",
        color: "#28a745",
      },
      Closed: {
        icon: <IconClosedSurvey height={12} width={12} className="align-svg" />,
        text: "CLOSED",
        color: "#888",
      },
    };

    const data = statusMap[props.survey.rubric_status];
    if (!data) return null;

    return (
      <div className="status-pill" style={{ borderColor: data.color, color: data.color }}>
        {data.icon}
        <span>{data.text}</span>
      </div>
    );
  };

  return (
    <Card className={props.status === "Closed" ? "card_inactive-ui" : "card_align-ui"}>
      <Card.Header className="card-header-clean">
        <div className="top-row">{renderStatus()}</div>

        <OverlayTooltip tip={props.name} placement="top">
          <div className="survey-title">{props.name.length > 22 ? props.name.slice(0, 22) + "..." : props.name}</div>
        </OverlayTooltip>

        <div className="question-box">
          <div className="question-number">
            {props.survey.questions.length}
          </div>
          <div className="question-text">Questions</div>
        </div>
      </Card.Header>

      <Card.Footer className="card-footer-clean">
        <div className="date-block">
          <div className="date-title">START DATE</div>
          <div className="date-val">
            <IconCalenderSurvey className="svg-calender" />
            <span className="date-label">{props.survey.new_start_date}</span>
          </div>
        </div>

        <div className="date-block">
          <div className="date-title right">END DATE</div>
          <div className="date-val">
            <IconCalenderSurvey className="svg-calender" />
            <span className="date-label">{props.survey.new_due_date}</span>
          </div>
        </div>
      </Card.Footer>
    </Card>
  );
}
export default withLabelsContext(RubricsCard);